// concepts/c5/c5.js — Concept 5 "Synthesis" SHARED behaviour
// ============================================================
// Loaded by all three c5 pages. Owns only what's identical everywhere: the
// mobile hamburger nav. Revision 1b (owner correction): the header is
// static now, not floating/sticky, so there is no scroll-driven header
// state to track here anymore. Page-specific scripts (home.js's
// scroll-story engine, floating store badges, etc.) live alongside each
// page and run independently after this file.

(() => {
  const menuButton = document.querySelector('[data-menu-button]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  function closeMobileNav() {
    if (!menuButton || !mobileNav) return;
    menuButton.setAttribute('aria-expanded', 'false');
    mobileNav.classList.remove('is-open');
  }

  function toggleMobileNav() {
    if (!menuButton || !mobileNav) return;
    const isOpen = mobileNav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(isOpen));
  }

  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', toggleMobileNav);
    mobileNav.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') closeMobileNav();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMobileNav();
    });
  }
})();
